// Day mode configurations
export const dayModes = {
  survival: {
    id: 'survival',
    name: 'Survival Day',
    emoji: '🔴',
    tagline: 'Just getting through today',
    description: 'Focus only on absolute essentials. Everything else can wait.',
    color: 'survival',
    bgColor: 'bg-survival-bg',
    textColor: 'text-survival-text',
    borderColor: 'border-survival-border',
    tasks: [
      { id: 1, text: 'Everyone fed', priority: 'Nutrition', skippable: false },
      { id: 2, text: 'Basic safety maintained', priority: 'Home', skippable: false },
      { id: 3, text: 'Prayer', priority: 'Habits', skippable: false },
    ],
    timeBlocks: [
      { duration: 15, label: 'Essential care' },
      { duration: 30, label: 'Rest when possible' },
    ],
    skipMessage: 'Everything else can wait. You are doing enough.',
    image: 'https://images.unsplash.com/photo-1759220948640-2195caaeb6e7?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  normal: {
    id: 'normal',
    name: 'Normal Day',
    emoji: '🟡',
    tagline: 'A regular, manageable day',
    description: 'Steady pace with reasonable expectations.',
    color: 'normal',
    bgColor: 'bg-normal-bg',
    textColor: 'text-normal-text',
    borderColor: 'border-normal-border',
    tasks: [
      { id: 1, text: 'Meals prepared', priority: 'Nutrition', skippable: false },
      { id: 2, text: 'Basic tidying (one room)', priority: 'Home', skippable: false },
      { id: 3, text: 'One load of laundry', priority: 'Home', skippable: false },
      { id: 4, text: 'Quality time with kids (activities / reading / homeschooling)', priority: 'Habits', skippable: false },
      { id: 5, text: 'Daily devotional', priority: 'Habits', skippable: false },
      { id: 6, text: 'One errand or admin task', priority: 'Home', skippable: true },
      { id: 7, text: 'Something just for you', priority: 'Habits', skippable: true },
    ],
    timeBlocks: [
      { duration: 15, label: 'Morning routine' },
      { duration: 30, label: 'Main task block' },
      { duration: 15, label: 'Evening reset' },
    ],
    skipMessage: 'The skippable tasks are extras. Core is enough.',
    image: 'https://images.unsplash.com/photo-1762199904164-fff3ac17fc9e?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  good: {
    id: 'good',
    name: 'Good Day',
    emoji: '🟢',
    tagline: 'Extra energy to spare',
    description: 'A day with capacity for a bit more.',
    color: 'good',
    bgColor: 'bg-good-bg',
    textColor: 'text-good-text',
    borderColor: 'border-good-border',
    tasks: [
      { id: 1, text: 'Meals with a little extra care', priority: 'Nutrition', skippable: false },
      { id: 2, text: 'Keeping it tidy', priority: 'Home', skippable: false },
      { id: 3, text: 'Laundry (wash, dry, fold)', priority: 'Home', skippable: false },
      { id: 4, text: 'Quality time with kids (activities / reading / homeschooling)', priority: 'Habits', skippable: false },
      { id: 5, text: 'Something just for you', priority: 'Habits', skippable: false },
      { id: 6, text: 'Daily devotional', priority: 'Habits', skippable: false },
      { id: 7, text: 'One deeper clean area', priority: 'Home', skippable: true },
      { id: 8, text: 'Errands or appointments', priority: 'Home', skippable: true },
    ],
    timeBlocks: [
      { duration: 15, label: 'Morning routine' },
      { duration: 30, label: 'Focus block 1' },
      { duration: 30, label: 'Focus block 2' },
      { duration: 15, label: 'Evening wind-down' },
    ],
    skipMessage: 'Even on good days, flexibility is key.',
    image: 'https://images.unsplash.com/photo-1762115331559-92659819dcf5?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
};

import { getCustomTasks } from './localStorage';

export const getDayModeConfig = (modeId) => {
  const baseConfig = dayModes[modeId];
  if (!baseConfig) return null;
  
  // Check for custom tasks
  const customTasks = getCustomTasks(modeId);
  if (customTasks) {
    return {
      ...baseConfig,
      tasks: customTasks,
    };
  }
  
  return baseConfig;
};

// Get default tasks for a day mode (ignoring custom overrides)
export const getDefaultTasks = (modeId) => {
  const baseConfig = dayModes[modeId];
  return baseConfig ? baseConfig.tasks : [];
};

export const getAllDayModes = () => {
  return Object.values(dayModes);
};
